import '../pages/Pages.css';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchPlus, faSearchMinus, faPrint } from '@fortawesome/free-solid-svg-icons';

const PDFViewerComponent = ({ document }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const goToPrevPage = () => setPageNumber(pageNumber - 1);
  const goToNextPage = () => setPageNumber(pageNumber + 1);
  const zoomIn = () => setScale(scale + 0.1);
  const zoomOut = () => setScale(scale > 0.1 ? scale - 0.1 : scale);

  const printDocument = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Print PDF</title></head><body>');
    printWindow.document.write('<iframe src="' + document + '" style="width: 100%; height: 100%;" frameborder="0"></iframe>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
  };

  return (
    <div className="pdf-viewer">
      <div className="controls">
        <button onClick={goToPrevPage} disabled={pageNumber <= 1}>
          Précédent
        </button>
        <button onClick={zoomOut} disabled={scale <= 0.1}>
          <FontAwesomeIcon icon={faSearchMinus} />
        </button>
        <span>
          <button onClick={printDocument}>
            <FontAwesomeIcon icon={faPrint} />
          </button>
        </span>
        <button onClick={zoomIn}>
          <FontAwesomeIcon icon={faSearchPlus} />
        </button>
        <button onClick={goToNextPage} disabled={pageNumber >= numPages}>
          Suivant
        </button>
      </div>
      <div className="page-info">
        {pageNumber} sur {numPages}
      </div>
      <div className="document-container">
        <Document
          file={document}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          <Page pageNumber={pageNumber} scale={scale} />
        </Document>
      </div>
    </div>
  );
};

export default PDFViewerComponent;
